<template>
  <div class="dados-pessoais-details">
    <page-header :title="title" />
    <page-section>
      <v-row no-gutters>
        <v-col class="mb-4">
          <field-section
            :label="$t('Nome_Completo')"
            :value="tag.nome | toPT_BRCapitalize"
            :is-restrict="$store.getters['tagFuncionario/isRestrict']('nome')"
          />
        </v-col>
        <v-col class="mb-4">
          <field-section
            :label="$t('Email')"
            :value="tag.email"
            :is-restrict="$store.getters['tagFuncionario/isRestrict']('email')"
          />
        </v-col>
        <v-col cols="12" class="mb-4">
          <field-section
            :label="$t('Data_Nasc')"
            :value="tag.dataNasc"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('dataNasc')
            "
          >
            <template #value>
              {{ tag.dataNasc | toLocaleDate }}
            </template>
          </field-section>
        </v-col>
      </v-row>
    </page-section>
    <page-section :group-label="$t('Contato_Emergencia')">
      <v-row no-gutters>
        <v-col class="mb-4">
          <field-section
            :label="$t('Nome_Contato')"
            :value="tag.nomeContato | toPT_BRCapitalize"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('nomeContato')
            "
          />
        </v-col>
        <v-col cols="6" class="mb-4">
          <field-section
            :label="$t('Email_Contato')"
            :value="tag.emailContato"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('emailContato')
            "
          />
        </v-col>
        <v-col cols="6" class="mb-4">
          <field-section
            :label="$t('Telefone_1')"
            :value="tag.fone1Contato"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('fone1Contato')
            "
          />
        </v-col>
        <v-col class="mb-4">
          <field-section
            :label="$t('Telefone_2')"
            :value="tag.fone2Contato"
            :is-restrict="
              $store.getters['tagFuncionario/isRestrict']('fone2Contato')
            "
          />
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="tag" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("Dados_Pessoais") || "") + " | %s",
  },
  components: { FieldSection, PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Dados_Pessoais"),
  }),
  computed: {
    tag() {
      return this.$store.state.tagFuncionario.data || {};
    },
  },
};
</script>

<style scoped></style>
